"use client";

import { useEffect } from "react";

/**
 * Intercepts native title attributes and creates CSS-only premium tooltips
 * This runs on the client side and transforms all [title] elements
 */
export function TitleTooltipInterceptor() {
  useEffect(() => {
    // Function to process elements with title attributes
    const processElements = () => {
      const elements = document.querySelectorAll("[title]:not([data-tooltip-processed])");
      
      elements.forEach((element) => {
        const title = element.getAttribute("title");
        if (!title) return;
        
        // Mark as processed
        element.setAttribute("data-tooltip-processed", "true");
        
        // Store the title in a data attribute and remove native title
        element.setAttribute("data-premium-tooltip", title);
        element.removeAttribute("title");
        
        // Add tooltip class for CSS styling
        element.classList.add("has-premium-tooltip");
      });
    };

    // Initial processing
    processElements();

    // Create mutation observer to handle dynamically added elements
    const observer = new MutationObserver((mutations) => {
      let shouldProcess = false;
      mutations.forEach((mutation) => {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          shouldProcess = true;
        }
        if (mutation.type === "attributes" && mutation.attributeName === "title") {
          shouldProcess = true;
        }
      });
      if (shouldProcess) {
        processElements();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["title"],
    });

    return () => observer.disconnect();
  }, []);

  return null;
}
